import React from 'react';
import Button from 'ui/elements/buttons/Button';
import { Hidden, useMediaQuery } from '@mui/material';
import EyeIcon from 'ui/elements/icons/EyeIcon';
import ChevronDownIcon from 'ui/elements/icons/ChevronDownIcon';
import styled from '@emotion/styled';
import { bluePlanetTheme } from 'ui/theme';
import { fontSizeSmall } from 'ui/theme/themeBluePlanet';

const PostTo = styled.span`
  font-weight: ${bluePlanetTheme.typography.fontWeightMedium};
  font-size: ${fontSizeSmall};
  color: ${bluePlanetTheme.bluePlanetPalette.grey.main};
  text-align: left;
`;

export default function VisibilityButton({ label, onClick }: { label: string; onClick: () => void }) {
  const isMobile = useMediaQuery(bluePlanetTheme.breakpoints.down('sm'));

  return (
    <Button kind="primary" color="greyLight" onClick={onClick}>
      <div
        className="u-flex u-flex-align-center u-flex-space-between"
        style={{ minWidth: isMobile ? undefined : '200px' }}
      >
        <div className="u-flex u-flex-align-center">
          <Hidden smDown>
            <EyeIcon className="u-half-spacing-right" />
          </Hidden>
          <div className="u-flex u-flex--column text-align-left">
            <PostTo>Post to:</PostTo>
            <span>{label}</span>
          </div>
        </div>
        <ChevronDownIcon className="u-half-spacing-left" />
      </div>
    </Button>
  );
}
